// https://github.com/wojtekmaj/react-date-picker
import React from 'react';
import { Form } from 'semantic-ui-react';
import DatePicker from 'react-date-picker/dist/entry.nostyle';
import moment from 'moment';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DATE_FORMAT_FOR_UI } from 'Common/Constants';

export class CalendarPickerField extends React.Component {
  static propTypes = {
    input: PropTypes.shape({
      onChange: PropTypes.func.isRequired,
      value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    }).isRequired,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string,
      warning: PropTypes.string,
    }),
    minDate: PropTypes.string,
    maxDate: PropTypes.string,
    useMoment: PropTypes.bool,
    dateFormat: PropTypes.string,
  };

  static defaultProps = {
    dateFormat: DATE_FORMAT_FOR_UI,
    useMoment: false,
  };

  handleChange = change => {
    const {
      dateFormat,
      useMoment,
      input: { onChange },
    } = this.props;
    let date = moment(change);
    onChange(
      !date.isValid() ? null : useMoment ? date : date.format(dateFormat)
    );
  };

  formatProps = () => {
    const { minDate, maxDate } = this.props;

    let props = {};
    const minDateMoment = moment(minDate);
    if (minDate && minDateMoment.isValid()) {
      props['minDate'] = minDateMoment.toDate();
    }

    const maxDateMoment = moment(maxDate);
    if (maxDate && maxDateMoment.isValid()) {
      props['maxDate'] = maxDateMoment.toDate();
    }

    return props;
  };

  render() {
    const {
      required,
      meta: { touched, error },
      input: { value },
      minDate,
      maxDate,
      label,
      fluid,
      className,
      ...rest
    } = this.props;
    return (
      <Form.Field error={touched && error ? true : false} required={required}>
        {label && <label>{label}</label>}
        <DatePicker
          value={value ? moment(value).toDate() : null}
          {...this.formatProps()}
          onChange={this.handleChange}
          minDetail={'decade'}
          className={classNames(
            className,
            fluid ? 'react-date-picker--fluid' : ''
          )}
          {...rest}
        />
        <div style={{ height: '10px' }}>
          {touched && error ? (
            <span className={'input--message-error'}>{error}</span>
          ) : null}
        </div>
      </Form.Field>
    );
  }
}

export function MonthPickerField(props) {
  return <CalendarPickerField maxDetail={'year'} {...props} />;
}



// WEBPACK FOOTER //
// ./src/common/ReduxFormFields/ReactDatePickerWrapper.js